var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-za",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M70.133 0h499.61v499.61H70.133z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-71.873) scale(1.0248)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.001 397.908V101.846l220.373 147.955L0 397.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.371 499.667l247.41-166.512h351.66v166.512h-599.07z",
    fill: "#00c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.465.007L749.422.02v166.54H397.76S137.762-1.64 134.465.007z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.001 62.47v39.352l220.373 147.955L0 397.894v39.35l277.564-187.467L.001 62.47z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.001 62.47V.007H92.6L386.63 198.95h362.79v101.737H386.63L92.598 499.6H0v-62.356l277.564-187.468L.001 62.47z",
    fill: "#093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.599.007h57.762l247.41 166.54h351.66v32.403h-362.79L92.61.007zm0 499.66h57.762l247.41-166.512h351.66v-32.402h-362.79L92.61 499.667z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZa);
export default __webpack_public_path__ + "static/media/za.124a451dc72b2dd7815b265e7678018a.svg";
export { ForwardRef as ReactComponent };